/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Notification from "./Notification";
import {getMappingObjectByRoute} from "../../../../api/utils/aemEndpointUtil";

class _NotificationHub extends Component {

    state = {
        notifications: [],
    };

    onRouteChanged = () => {
        this.clearNotifications(this.populateNotifications);
    };

    onRemoveNotification = (key) => {
        if (key) {
            this.setState({notifications: this.state.notifications.filter(item => item.key !== key)});
        }
    };

    populateNotifications = () => {
        const {location, mapping} = this.props;
        const path = location.pathname;
        if (mapping && path) {
            const pathParts = (path === "/") ? [""] : path.split("/");
            let messages = [];

            pathParts.forEach((part, i, arr) => {
                const mapObject = getMappingObjectByRoute(mapping, part);
                if (mapObject && (mapObject.showMessagesOnChildPages || i === (pathParts.length - 1))) {
                    messages.push({
                        key: arr.slice(0, i+1).join("/") || "/",
                        message: mapObject.informationMessage,
                        until: mapObject.showInformationMessageUntil,
                    })
                }

                if (mapObject && mapObject.maintenanceEnabled && mapObject.maintenanceMessage && i === (pathParts.length - 1)) {
                    messages.unshift({
                        key:  arr.slice(0, i+1).join("/") || "/",
                        message: mapObject.maintenanceMessage,
                        enabled: mapObject.maintenanceEnabled
                    });
                }
            });

            this.setState({notifications: messages});
        }
    };

    clearNotifications = (callback) => {
        this.setState({notifications: []}, callback);
    };


    componentDidMount() {
        if (this.props.location) {
            this.onRouteChanged();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location && prevProps.location && this.props.location.pathname !== prevProps.location.pathname || this.props.mapping !== prevProps.mapping) {
            this.clearNotifications();
            this.onRouteChanged();
        }
    }

    render() {
        return this.state.notifications.length > 0 ? <div className={"row p-margin-none"}>
            {this.state.notifications.map(notification => <Notification
                key={notification.key}
                id={notification.key}
                until={notification.until}
                enabled={notification.enabled}
                onRemoveNotification={this.onRemoveNotification}
                message={notification.message}/>)}
        </div> : null
    }
}

const mapStateToProps = (state) => ({
    mapping: state.myPuratos_dashboard.mapping,
});

_NotificationHub.defaultProps = {};
_NotificationHub.propTypes = {
    mapping: PropTypes.object,
};

const NotificationHub = withRouter(connect(mapStateToProps, {})(_NotificationHub));
export default NotificationHub;
